import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export function useWebsitePageTags() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['website-page-tags'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('website_tasks')
        .select('page_tags')
        .is('deleted_at', null);

      if (error) throw error;

      const allTags = new Set<string>();
      data?.forEach((task: { page_tags: string[] | null }) => {
        task.page_tags?.forEach(tag => allTags.add(tag));
      });

      return Array.from(allTags).sort();
    },
    enabled: !!user,
  });
}
